import { Component, OnInit, Injector, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

const swal = require('sweetalert');
import { BehaviorSubject } from 'rxjs';
import { UsuariosService } from '../usuarios.service';
import { LoadingService } from '../../../../util/loader.service';
import { Usuario } from '../../../../models/usuario';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { moment } from 'ngx-bootstrap/chronos/test/chain';


@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-usuario-auxiliar',
  templateUrl: './auxiliar-usuarios.component.html',
  styleUrls: ['./auxiliar-usuarios.component.scss']
})
export class UsuariosAuxiliarComponent implements OnInit, OnDestroy {
  blur = false;
  valForm: FormGroup;
  valFormEmpresa: FormGroup;
  valFormCPF: FormGroup;
  valFormDocumento: FormGroup;
  router: Router;
  id: any;
  empresas: Array<any>;
  centroCusto: Array<any>;
  codigoEmpresa: number;
  empresaVinculada: any;
  usuario: Usuario;
  tipoUsuario: any[];
  edicao = false;
  rows: Object[] = [];
  empresaDisable = true;
  buttonType;
  empresaAssociada: any;
  empresaSelecionada: any;
  documentoEstrangeiro: string = "";
  paises: Array<any>;
  tipoDocumento: Array<any>;
  dataDeNascimento;
  // Datepicker
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  bsConfig = {
    containerClass: 'theme-angle',
    dateInputFormat: 'DD/MM/YYYY'
  };

  constructor(public service: UsuariosService, public injector: Injector, fb: FormBuilder,
    private route: ActivatedRoute, private routerNavigate: Router, public loader: LoadingService, private _localeService: BsLocaleService) {
    this._localeService.use('pt');
    this.usuario = new Usuario();

    const sobrenome = /[A-Za-z\u00C0-\u00FF]+[\s[A-Za-z\u00C0-\u00FF-]*/;
    const email = /[\w]+[\w-.]{2}[\w-.]*@[\w-]+\.[\w-.]*/;
    // VALIDAÇÃO DO FORM
    this.valForm = fb.group({
      'usuarioNome': [null, [Validators.required]],
      'usuarioTelefone': [null, [Validators.minLength(11), Validators.required]],
      'usuarioEmail': [null, [Validators.pattern(email), Validators.required]],
      'dataNascimento': [null, Validators.required]
    });



    // VERIFICAR SE O FORM ABRIU EM MODO DE EDIÇÃO
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id != undefined && this.id != null) {
      this.loader.show('body');
      this.service.obterPorCodigo(this.id)
        .subscribe(itens => {
          this.loader.hide('body');
          this.usuario = itens;
          this.dataDeNascimento =  moment(new Date(this.usuario.data_nascimento)).format("DD/MM/YYYY");
        });
      this.edicao = true;

    } else {
      this.edicao = false;
    }
    // VERIFICAR SE O FORM ABRIU EM MODO DE EDIÇÃO

  }

  submitForm($ev, value, buttonType: string) {
    $ev.preventDefault();
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {

      this.loader.show('body');
      this.usuario.data_nascimento = this.dataDeNascimento;
      this.service.atualizarUsuario(this.usuario)
        .subscribe(result => {
          this.loader.hide('body');
          this.usuario.data_nascimento = new Date(result.data_nascimento);
          this.callbackSave(result);
        });
    }
  }




  callbackSave(result) {
    if (result == true) {
      swal('Atenção', 'Usuário salvo com sucesso.', 'success');
      this.valForm.reset();
      this.routerNavigate.navigate(['/v1/usuario']);
    }
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {

  }



  doSelectAdmin(admin: boolean) {
    if (admin) {

    }
  }

  setAdmin(e) {
    this.usuario.administrador = e.target.checked;
  }



  onFilterChange(eve: any) {

  }
}
